/* eslint-disable react-hooks/exhaustive-deps */

/*
*   clicked element bt ContentClickForm.tsx
*/

import { useEffect } from "react"
import { ILanding, SELECT_TYPE,  } from "../data/interfaces"
import { ILandingStore, useLandingStore } from "../data/store"
import { ID } from "src/libs/interfaces/layouts"
import { useSyncState } from "src/modules/pe-basic-module/hooks/useSyncState"
 
export default function useSelectedContent(): any {
    const selectedLayer : ID                    = useLandingStore((state: ILandingStore) => state.selectedLayer)
    const selectedMeat : ID                     = useLandingStore((state: ILandingStore) => state.selectedMeat)
    const selectedFloat : ID                    = useLandingStore((state: ILandingStore) => state.selectedFloat)
    const currentLanding: ILanding              = useLandingStore((state: ILandingStore) => state.currentLanding)
    const selectedType: SELECT_TYPE             = useLandingStore((state: ILandingStore) => state.selectedType)
    const data                                  = useSyncState<any>({})
    const getData = () => { 
        const section = currentLanding.sections.find(section => section.id === selectedLayer)
        if( selectedType === SELECT_TYPE.CONTENT ) { 
            const _data = section?.data.find(_d => _d.id === selectedMeat)
            data.set(_data) 
            return
        }
        if( selectedType === SELECT_TYPE.FLOAT ) {
            const _floatData = section?.floats.find(float => float.id === selectedFloat) 
            data.set( _floatData ) 
            return
        }
        if( selectedType === SELECT_TYPE.TITLE ) { 
            data.set( section?.title )
            return
        }
        data.set({})
        useLandingStore.setState({ selectedType: SELECT_TYPE.NONE })
    }
    useEffect(() => { 
        getData()
    }, [ selectedLayer, selectedMeat, selectedFloat, selectedType ])

    const ret = {
        data: data.get(),
        type: selectedType
    } 
    
    // console.log(ret)
    
    return ret
}